module.exports = __webpack_public_path__ + "static/media/junk-car.0ecb6286.jpg";